module.exports = __webpack_public_path__ + "img/election-old.e2706fa.webp";